import React from "react";
import AlertList from "alerts/account_alerts/AlertList";
import LeftIndent from "utils/LeftIndent";
import RandomQuoteGenerator from "utils/RandomQuoteGenerator";
import { Button } from "react-bootstrap";

class AccountAlerts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      allAlerts: [
        ...this.props.alerts.todaysAlerts,
        ...this.props.alerts.yesterdaysAlerts,
        ...this.props.alerts.otherAlerts,
      ],
    };
  }

  resolveAll = () => {
    let ids = this.state.allAlerts.map((alert) => {
      return alert.id;
    });
    this.props.resolveAll(ids, true, "account-alerts");
  };

  render() {
    const today = new Date();
    const yesterday = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 1
    );
    const twoDaysAgo = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 2
    );
    let quote = RandomQuoteGenerator(this.props);
    let allResolved =
      this.props.alerts.todaysAlerts.length == 0 &&
      this.props.alerts.yesterdaysAlerts.length == 0 &&
      this.props.alerts.otherAlerts.length == 0;
    return (
      <>
        <div className="d-flex account-alerts-header">
          <h1>
            {this.props.resolvedView ? "Resolved Alerts" : "Alerts"} for{" "}
            {this.props.clientName}
          </h1>
          {!this.props.resolvedView && !allResolved && (
            <Button
              variant="success"
              style={{ zIndex: "999" }}
              className="ml-auto mb-5 height-min-content"
              onClick={this.resolveAll}>
              <i className="fas fa-check"></i>
              Resolve All
            </Button>
          )}
        </div>

        {!this.props.resolvedView && allResolved ? (
          <>
            <div className="all-resolved">
              <p style={{padding: "15px"}}>All set for now!</p>
              <div className="success-quote d-flex flex-column">
                <h4>"{quote.text}"</h4>
                <h5 className="ml-auto">- {quote.author}</h5>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="mb-5">
              <LeftIndent>
                <div className="alert-group">
                  <h3>Today's Alerts ({today.toLocaleDateString()})</h3>
                  <AlertList
                    resolveAlert={this.props.resolveAlert}
                    snoozeAlert={this.props.snoozeAlert}
                    alerts={this.props.alerts.todaysAlerts}
                    userEmail={this.props.userEmail}
                    userSubscriptions={this.props.userSubscriptions}
                  />
                </div>
              </LeftIndent>
            </div>
            <div className="mb-5">
              <LeftIndent>
                <div className="alert-group">
                  <h3>Yesterday's Alerts ({yesterday.toLocaleDateString()})</h3>
                  <AlertList
                    resolveAlert={this.props.resolveAlert}
                    snoozeAlert={this.props.snoozeAlert}
                    alerts={this.props.alerts.yesterdaysAlerts}
                    userEmail={this.props.userEmail}
                    userSubscriptions={this.props.userSubscriptions}
                  />
                </div>
              </LeftIndent>
            </div>
            <div className="mb-5">
              <LeftIndent>
                <div className="alert-group">
                  <h3>
                    All Other Alerts (including and prior to{" "}
                    {twoDaysAgo.toLocaleDateString()})
                  </h3>
                  <AlertList
                    resolveAlert={this.props.resolveAlert}
                    snoozeAlert={this.props.snoozeAlert}
                    alerts={this.props.alerts.otherAlerts}
                    userEmail={this.props.userEmail}
                    userSubscriptions={this.props.userSubscriptions}
                  />
                </div>
              </LeftIndent>
            </div>
          </>
        )}
      </>
    );
  }
}

export default AccountAlerts;
